import { Model } from './model'

export class Account extends Model {
  name: string
  hauptbahnhofId: string
  options: any

  constructor(obj = {}) {
    super(obj)
  }
}
